var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wizardstepjobmatchjobgoal text-left" },
    [
      _vm.noJobGoals
        ? [
            _c("div", { staticClass: "empty-items" }, [
              _c(
                "div",
                {
                  staticClass:
                    "job-goal-item bg-white rounded py-3 px-4 soft-shadow d-flex align-items-center border border-success mr-5",
                },
                [
                  _c("b-icon", {
                    staticClass: "mr-4",
                    attrs: {
                      icon: "check",
                      "font-scale": "1.4",
                      variant: "success",
                    },
                  }),
                  _c("b-skeleton", {
                    staticClass: "mb-0 cursor-default",
                    attrs: { width: "50%", animation: "" },
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass:
                    "job-goal-item bg-white rounded py-3 px-4 soft-shadow d-flex align-items-center border border-success ml-5",
                },
                [
                  _c("b-icon", {
                    staticClass: "mr-4",
                    attrs: {
                      icon: "check",
                      "font-scale": "1.4",
                      variant: "success",
                    },
                  }),
                  _c("b-skeleton", {
                    staticClass: "mb-0 cursor-default",
                    attrs: { width: "50%", animation: "" },
                  }),
                ],
                1
              ),
            ]),
            _c(
              "div",
              {
                staticClass:
                  "button-section mt-5 d-flex flex-column align-items-center",
              },
              [
                _c("div", { staticClass: "text" }, [
                  _vm._v(" " + _vm._s(_vm.wizardstep.noJobGoalsText)),
                ]),
                _vm.wizardstep.jobGoalsLink !== "" &&
                _vm.wizardstep.jobGoalButtonText !== ""
                  ? _c(
                      "a",
                      {
                        staticClass: "mt-4",
                        attrs: { href: _vm.wizardstep.jobGoalsLink },
                      },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "btn btn-transparent",
                            on: {
                              click: function ($event) {
                                return _vm.buttonClicked()
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.wizardstep.jobGoalButtonText))]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
          ]
        : _vm.jobGoals.length > 0
        ? _vm._l(_vm.jobGoals, function (section, index) {
            return _c(
              "div",
              { key: index, staticClass: "section mb-4" },
              [
                section.goals.length > 0
                  ? [
                      _c("p", { staticClass: "m-0 mb-2" }, [
                        _vm._v(_vm._s(section.text)),
                      ]),
                      _vm._l(section.goals, function (item, indx) {
                        return _c(
                          "span",
                          { key: indx },
                          [
                            item !== undefined
                              ? _c("OccupationListItem", {
                                  attrs: { item: item, source: "JobGoal" },
                                })
                              : _vm._e(),
                          ],
                          1
                        )
                      }),
                    ]
                  : _vm._e(),
              ],
              2
            )
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }